import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";

import { Helmet } from "react-helmet";

import { Section } from "react-scroll-section";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";


function Cex() {
 
  return (
    <div className="smart_contract smart_SR">
      <header className="newpage nft_new_page fixed_header">
        {/* <Header /> */}
        <NewHead />
      </header>
      <div className="paddin_immner">
        <main className=" carer_page">
          <span>
            <Helmet>
              <title>
                Smart Contract Audit Company | Smart Contract Audit Services |
                Beleaf Technologies
              </title>
              <link
                rel="canonical"
                href="https://beleaftechnologies.com/smart-contract-auditing-service-company"
              />
              <meta
                name="title"
                content="Smart Contract Audit Company | Smart Contract Audit Services | Beleaf Technologies"
              />
              <meta
                name="description"
                content="Get the complete security smart contract audit services from the best smart contract development company . Beleaf Technologies provides hassle-free smart contract audit for Ethereum, EOS, Tron, Waves, Stellar, Minter, Tezos and more"
              />
              <meta
                name="keywords"
                content="smart contract audit services, smart contract auditing services, smart contract audit companies, smart contract security audit, smart contract development company, smart contract audit, Smart Contract Solutions"
              />
              <meta
                property="og:title"
                content="Smart Contract Audit Company | Smart Contract Audit Services | Beleaf Technologies"
              />
              <meta property="og:site_name" content="Beleaf Technologies" />

              <meta
                property="og:description"
                content="Get the complete security smart contract audit services from the best smart contract development company . Beleaf Technologies provides hassle-free smart contract audit for Ethereum, EOS, Tron, Waves, Stellar, Minter, Tezos and more"
              />
              <meta property="og:type" content="website" />

              <meta name="twitter:card" content="summary" />
              <meta name="twitter:site" content="@BeleafTech" />
              <meta
                name="twitter:title"
                content="Smart Contract Audit Company | Smart Contract Audit Services | Beleaf Technologies"
              />
              <meta
                name="twitter:description"
                content="Get the complete security smart contract audit services from the best smart contract development company . Beleaf Technologies provides hassle-free smart contract audit for Ethereum, EOS, Tron, Waves, Stellar, Minter, Tezos and more"
              />

              <meta name="twitter:image:alt" content="Beleaf Technologies" />
            </Helmet>
            <div className="ourserveic_banner ourserveic_bannernft bg_img_none bg-white NFT_first h-fit">
              {/* <div className="bg-overlay"></div> */}
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="service_content service_contentnew smart_opaddin padding_sesion">
                      <h1>Smart Contract Audit Company</h1>
                      <p>
                        Secure your Blockchain Projects with Our Unrivaled Smart
                        Contract Audit Services!!!
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Get Free Consultation"
                      >
                        Get Free Consultation
                      </Button>
                      {/* <div className="pt-4 pb-0 mt-1 banner_text_section">
                          <Button>Demo</Button>
                        </div> */}
                    </div>
              
                  </div>
                  <div className="col-lg-6">
                    <div className="Smart_Contract">
                      <img
                        src={require("../../image/smart/pexels-karolina-grabowska.webp")}
                        alt="blockchian"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/smart/pexels-zadok-p.webp")}
                      alt="blockchian"
                      className="image_radious"
                    />
                  </div>
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className="">
                        Smart Contract Auditing Service Company
                      </h2>
                      <p className="">
                        Businesses have begun to use smart contracts development
                        services to improve their security quotient in the face
                        of escalating trust difficulties in the digital age. A
                        minor error in creating and executing smart contracts,
                        on the other hand, can result in massive financial
                        losses. This is where smart contracts security audits
                        come into play.
                        <br />
                        To assure the quality of the code, our Blockchain
                        professionals at Beleaf use their knowledge and
                        expertise to audit smart contracts for present and
                        potential errors, security flaws, compilation issues,
                        and other concerns.
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Explore more"
                      >
                        Explore more
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className="">
                        Who is in need of Smart Contract Audits?
                      </h2>
                      <p className="">
                        In general, any software product generated must be
                        tested prior to distribution to verify that it is
                        bug-free. Similarly, smart contract auditing is required
                        to ensure error-free digital contracts, and this service
                        will be required by,
                      </p>
                      <ul className="list_item_sec">
                        <li>Industries Using Smart Contracts</li>
                        <li>Owners and managers of ICO startups</li>
                        <li>Decentralized Application product owners</li>
                        <li>
                          Anyone who requires the trust of stakeholders and
                          investors.
                        </li>
                      </ul>
                      <Button
                         data-toggle="modal"
                          data-target="#myModal"
                      >
                        Let’s Discuss
                      </Button>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/smart/pexels-mikhail-nilov.webp")}
                      alt="blockchian"
                      className="image_radious"
                    />
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/smart/pexels-anete-lusina.webp")}
                      alt="blockchian"
                      className="image_radious"
                    />
                  </div>
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className="">
                        Why is Smart Contract Auditing is necessary?
                      </h2>
                      <p className="">
                        The importance of correcting the smart contract code
                        before deployment is increasing because the code cannot
                        be modified once it is posted on the blockchain. The
                        effect of activating smart contracts without sufficient
                        auditing could result in the contract failing to
                        function properly or in the theft or loss of personal
                        data. As a result, smart contract auditing is critical
                        before deploying them on the main network. Some of the
                        benefits of smart contract auditing are described below.
                      </p>
                      <ul className="list_item_sec">
                        <li>Prompt Operation of Smart contract</li>
                        <li>Code optimization</li>
                        <li>Execute the code quickly</li>
                        <li>Reestablish authorisation</li>
                        <li>Ensure self-assurance</li>
                        <li>It saves both time and money</li>
                      </ul>
                      {/* <Button data-toggle="modal" data-target="#myModal">
                        Let’s Discuss
                      </Button> */}
                      <div className="d-flex justify-content-center respozrfve_nuttn">
                        <div className="button_why_devee">
                          <a
                            href="https://wa.me/7904323274"
                            target="_blank"
                            className="m-0 mr-2"
                          >
                            Connect Whatsapp
                          </a>
                        </div>
                        <div className="button_why_devee">
                          {/* <a
                            href="https://join.skype.com/invite/wg5IW8g4Uaca"
                            target="_blank"
                            className="m-0"
                          >
                            Connect Skype
                          </a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto ">
                      <h2 className="text-center text_center_new">
                        Our Smart Contract Auditing Services
                      </h2>
                      <p className="text-center">
                        Beleaf, a well-known smart contract audit firm, provides
                        end-to-end smart contract audit services to assist
                        organisations of all sizes in launching highly secure
                        and error-free Blockchain applications.
                      </p>
                    </div>
                    <ul className="row list_item_d justify-content-center">
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <span className="logo_domeie">01</span>
                            </div>
                            <h3>Comprehensive Smart Contract Audit</h3>
                            <p>
                              We do a complete security audit of smart
                              contracts, which includes dynamic analysis, formal
                              verification, static analysis, and manual testing.
                              In order to combat common attacks, our team
                              employs cutting-edge tools such as Sol-profiler,
                              Oyente, Slither, Securify, and Solhint.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <span className="logo_domeie">02</span>
                            </div>
                            <h3>dApp Security Audit</h3>
                            <p>
                              Our cybersecurity experts identify all security
                              flaws by performing a safe and secure attack
                              simulation in test environments using a unique
                              Dapp security process-like penetration testing
                              method.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <span className="logo_domeie">03</span>
                            </div>
                            <h3>DEX Security Audit</h3>
                            <p>
                              To secure the long-term operation of the exchange
                              business, our professional smart contract team
                              audits your decentralised exchange contracts using
                              specific procedures such as business logic, data
                              maintenance, user privacy and data, and
                              infrastructure.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <span className="logo_domeie">04</span>
                            </div>
                            <h3>Blockchain Protocol Audit</h3>
                            <p>
                              We do blockchain protocol auditing to increase
                              platform security through procedures such as
                              signature security encryption, business logic,
                              consensus mechanism security assessment, and
                              tokenomics implementation.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <span className="logo_domeie">05</span>
                            </div>
                            <h3>Digital Wallet Security Audit</h3>
                            <p>
                              The security of digital wallets is ensured by
                              establishing a careful auditing procedure that
                              encompasses the security of cryptographic private
                              keys, data privacy, and the wallet's secure and
                              consistent operation.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <span className="logo_domeie">06</span>
                            </div>
                            <h3>Security Consulting</h3>
                            <p>
                              We help with every area of network security,
                              including discovering security vulnerabilities. To
                              gratify our partners, our staff has adhered to
                              security since its inception.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white pt-0">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_center_new">
                        Blockchain Platforms That We Audit
                      </h2>
                      <p className="text-center">
                        We do comprehensive smart contract security assessments
                        on various Blockchain platforms to assist you in
                        launching an error-free smart contract application on
                        your preferred platform.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/smart/ethereum-eth-logo1.webp")}
                        alt="blockchian"
                      />
                      <h3>Ethereum</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/smart/tezos-xtz-logo.webp")}
                        alt="blockchian"
                      />
                      <h3>Tezos</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/smart/cosmos-atom-logo.webp")}
                        alt="blockchian"
                      />
                      <h3>Cosmos</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/smart/algorand-algo-logo..webp")}
                        alt="blockchian"
                      />
                      <h3>Algorand</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/smart/polkadot-new-dot.webp")}
                        alt="blockchian"
                      />
                      <h3>Polkadot</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/smart/solana-sol-logo.webp")}
                        alt="blockchian"
                      />
                      <h3>Solana</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/ai/binance.webp")}
                        alt="blockchian"
                      />
                      <h3>Binance</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/smart/tron-trx-logo.webp")}
                        alt="blockchian"
                      />
                      <h3>TRON</h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="contanineee_circle">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="first_section_crypto colo_white card_CTAA">
                        <h2 className="">
                          Empower Your Business Platform With Smart Contract
                          Integration! Let’s Chat
                        </h2>
                        <a
                          href="tel:+91 80567 86622"
                          target="_blank"
                          className="grabcall"
                        >
                          Start A Conversation{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-blue">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto colo_white">
                      <h2 className="">
                        Projects That Require Security Audits
                      </h2>
                      <p className="">
                        Whether executing Metaverse smart contract audit or{" "}
                        <br />
                        DApp smart contract audit, our innovative audit
                        procedures,
                        <br /> combined with a thorough examination by our
                        subject matter experts, <br />
                        ensure that your project is high on security and
                        performance.
                      </p>
                    </div>
                    <ul className="row list_item_d justify-content-center">
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>1</span>
                          <div>
                            <h3>DeFi Smart Contract Audit</h3>
                            <p>
                              We offer DeFi smart contract auditing services for
                              DeFi initiatives with a large number of players or
                              transactions worth millions of dollars.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>2</span>
                          <div>
                            <h3>Blockchain Protocol Audit</h3>
                            <p>
                              We offer Blockchain protocol auditing services to
                              make your protocol more safe and resistant to
                              real-world cyber threats.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>3</span>
                          <div>
                            <h3>dApp Smart Contract Audit</h3>
                            <p>
                              Beleaf specializes in protecting complex dApp
                              codebases and creating permissionless, secure, and
                              immutable decentralized apps.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>4</span>
                          <div>
                            <h3>ICO Smart Contract Audit</h3>
                            <p>
                              Our experts conduct ICO smart contract audits to
                              ensure that the soft cap, hard cap, and other
                              functionality do not change after the token sale.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>5</span>
                          <div>
                            <h3>NFT Smart Contract Audit</h3>
                            <p>
                              Our expert team of NFT smart contract audit
                              specialists ensures that your funds are secure and
                              that you receive the necessary NFT verification
                              stamp.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>6</span>
                          <div>
                            <h3>Decentralized Application Audit</h3>
                            <p>
                              We have professionals who can audit the front end
                              and back end of any decentralized application in
                              addition to the Blockchain side.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  {/* <div className="col-lg-6">
                    <div className="monky_posu_div">
                      <img
                        src={require("../../image/new/NFT/section-hero-image-1.png")}
                        alt="techstack"
                        className="markey_place_img"
                      />
                    </div>
                  </div> */}
                </div>
              </div>
            </section>
            <section className="section bg-light turstss_blss">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto ">
                      <h2 className="text-center text_center_new">
                        Industries for which we offer smart contract development
                        services
                      </h2>
                      <p className="text-center">
                        Due to the growing trust difficulties, businesses have
                        begun utilizing audit services from reputable audit
                        firms at the best smart contract audit cost. For the
                        past couple of years, Beleaf has been one such company
                        that has offered smart contract audit services to its
                        customers at the most competitive pricing.
                      </p>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <img
                          src={require("../../image/smart/tusreeee.webp")}
                          alt="techstack"
                          className="markey_place_img"
                        />
                      </div>
                      <div className="col-lg-6">
                        <ul className="list_fetures contentce_flex">
                          <li>MLM</li>
                          <li>Game</li>
                          <li>DEX</li>
                          <li>DApp</li>
                          <li>Trading</li>
                          <li>Startup</li>
                          <li>Real Estate</li>
                          <li>Education</li>
                          <li>Agriculture</li>
                          <li>Healthcare</li>
                          <li>Insurance</li>

                          <li>Rental</li>
                          <li>Accounting & finance</li>
                          <li>Warehouse</li>
                          <li>Charity</li>
                        </ul>
                      </div>
                      <div className="col-lg-12 col_CTA_btn">
                        <div className="img_clas_butn first_section_crypto ">
                          <a href="https://wa.me/7904323274">
                            <Button
                            // data-toggle="modal"
                            // data-target="#myModal"
                            // aria-label="Talk To Our Blockchain Experts"
                            >
                              Talk To Our Blockchain Experts
                            </Button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/smart/pexels-fauxels.webp")}
                      alt="techstack"
                      className="image_radious"
                    />
                  </div>
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className="">
                        End-to-End Process for Our Smart Contract Audit
                      </h2>
                      <p className="">
                        Our smart contract security developers use a smart
                        contract audit process to ensure that your smart
                        contract is credible at its core.
                      </p>
                      <ul className="list_item_sec">
                        <li>
                          Assembling Specifications and Client Consultation
                        </li>
                        <li>Automated Review and Testing</li>
                        <li>Manual Analysis and Testing</li>
                        <li>Audit Report and Fixing</li>
                        <li>Initial Audit Report Submission</li>
                        <li>Issue Fixing by Developers</li>
                        <li>Inspecting the Rectified Code</li>
                        <li>Final Report Documentation and Submission</li>
                      </ul>
                      {/* <Button data-toggle="modal" data-target="#myModal">
                        Let’s Discuss
                      </Button> */}
                      <div className="d-flex justify-content-center">
                        <div className="button_why_devee">
                          <a
                            href="https://wa.me/7904323274"
                            target="_blank"
                            className="m-0 mr-2"
                          >
                            Connect Whatsapp
                          </a>
                        </div>
                        <div className="button_why_devee">
                          {/* <a
                            href="https://join.skype.com/invite/wg5IW8g4Uaca"
                            target="_blank"
                            className="m-0"
                          >
                            Connect Skype
                          </a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className="">
                        Why should you choose Beleaf as your Smart Contract
                        Audit Company?
                      </h2>
                      <p className="">
                        By cooperating with Beleaf, you can rely on a team of
                        multidisciplinary smart contract auditors with
                        real-world experience establishing success stories.
                      </p>
                      <ul className="list_item_sec">
                        <li>Detailed Report</li>
                        <li>Extensive research</li>
                        <li>Transparency is assured.</li>
                        <li>Clear Audit Metrics</li>
                        <li>seasoned group</li>
                        <li>100+ smart contracts have been audited.</li>
                        <li>Proactive approach</li>
                      </ul>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Let’s Discuss"
                        className="mt-0"
                      >
                        Let’s Discuss
                      </Button>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/smart/pexels-fauxels-0.webp")}
                      alt="techstack"
                      className="image_radious"
                    />
                  </div>
                </div>
              </div>
            </section>
            <Section id="about why new_faq bg_white CEX_faq">
              <section className="section bg_white CEX_faq" id="">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 d-flex justify-content-center align-items-center">
                      <div className="whybelaf faq">
                        <h2 className="">
                          Frequently asked <br />
                          Question
                        </h2>
                        <p></p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="comtent">
                        <div id="main">
                          <div className="container">
                            <div className="accordion" id="faq">
                              <div className="card">
                                <div className="card-header" id="faqhead1">
                                  <a
                                    href="#"
                                    className="btn btn-header-link"
                                    data-toggle="collapse"
                                    data-target="#faq1"
                                    aria-expanded="true"
                                    aria-controls="faq1"
                                  >
                                    How much does a smart contract audit cost?
                                  </a>
                                </div>

                                <div
                                  id="faq1"
                                  className="collapse show"
                                  aria-labelledby="faqhead1"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    The cost of executing smart contract audits
                                    is determined by factors such as the scale
                                    of the project, the type of Blockchain
                                    platform used, the number of individuals
                                    involved in the auditing process, and the
                                    team's workflow.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead2">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq2"
                                    aria-expanded="true"
                                    aria-controls="faq2"
                                  >
                                    How long does it take to audit an Ethereum
                                    smart contract?
                                  </a>
                                </div>

                                <div
                                  id="faq2"
                                  className="collapse"
                                  aria-labelledby="faqhead2"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    The time required for an Ethereum smart
                                    contract audit is determined by the
                                    project's size and complexity, team size,
                                    tools and technologies employed, and other
                                    factors.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead3">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq3"
                                    aria-expanded="true"
                                    aria-controls="faq3"
                                  >
                                    What is the significance of smart contract
                                    auditing?
                                  </a>
                                </div>

                                <div
                                  id="faq3"
                                  className="collapse"
                                  aria-labelledby="faqhead3"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Smart contract audits are necessary to
                                    protect an application from cyber-attacks,
                                    eliminate post-deployment errors, resolve
                                    compilation issues, and save developers'
                                    time.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead4">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq4"
                                    aria-expanded="true"
                                    aria-controls="faq4"
                                  >
                                    Where can I get a smart contract audit?
                                  </a>
                                </div>

                                <div
                                  id="faq4"
                                  className="collapse"
                                  aria-labelledby="faqhead4"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    An experienced and well-known smart contract
                                    audit organization can provide smart
                                    contract audit services tailored to your
                                    specific business needs.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead5">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq5"
                                    aria-expanded="true"
                                    aria-controls="faq5"
                                  >
                                    What are the advantages to having your smart
                                    contract audited?
                                  </a>
                                </div>

                                <div
                                  id="faq5"
                                  className="collapse"
                                  aria-labelledby="faqhead5"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    The following are some of the advantages of
                                    having your smart contract audited by a
                                    reputable auditing firm:
                                    <ul>
                                      <li>Removes post-deployment mistakes</li>
                                      <li>Protects against cyber assaults</li>
                                      <li>Developers' time is saved.</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </Section>
          </span>
          {/* <Commonpage /> */}
        </main>
      </div>

      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Cex;
